module.exports = __webpack_public_path__ + "img/familypic.a82dc3f1.png";